import { Direction, Directionality } from '@angular/cdk/bidi';
import { DOCUMENT, inject, Injectable } from '@angular/core';

const RTL_CULTURES = new Set(['ar']);

@Injectable({ providedIn: 'root' })
export class CustomDirectionality extends Directionality {
  readonly #document = inject(DOCUMENT);

  setByCulture(culture: string): void {
    const direction: Direction = RTL_CULTURES.has(culture) ? 'rtl' : 'ltr';

    this.#document.documentElement.dir = direction;
    this.valueSignal.set(direction);
    this.change.emit(direction);
  }
}
